import {
  Avatar,
  Container,
  Flex,
  Grid,
  Heading,
  HStack,
  Icon,
  Skeleton,
  Stack, Text
} from '@chakra-ui/react'
import { faGear } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import type { FlexGroup } from 'BrokerTsLib/src/dtos'
import { useGetFlexGroupType } from 'BrokerTsLib/src/hooks/useFlexGroup'
import { useNavigate } from 'react-router-dom'

import { HeaderButton } from '@/components'
import { Edit, Group, TextUnorderedList } from '@/icons'

import { ValidityBadge } from '../../components/ValidityBadge'

export const FlexGroupHeader = ({
  flexGroup,
  isLoading,
}: {
  flexGroup?: FlexGroup
  isLoading?: boolean
}) => {
  const type = useGetFlexGroupType(flexGroup?.type)
  const navigate = useNavigate()
  return (
    <Grid
      sx={{
        h: { base: 64, sm: 56 },
        placeItems: 'center',
        position: 'relative',
        bg: 'dashboard-header-bg',
      }}
    >
      <Container>
        <Flex
          sx={{
            position: 'relative',
            fontWeight: 'medium',
            zIndex: 1,
            color: 'white',
            justifyContent: 'space-between',
            flexDir: {
              base: 'column',
              lg: 'row',
            },
            gap: { base: 4, lg: 6 },
            pl: { base: 0, sm: 4 },
            pt: { base: 4, lg: 0 },
          }}
        >
          <Flex
            sx={{
              gap: { base: 4, lg: 6 },
            }}
          >
            <Avatar size={'2xl'} colorScheme="gray">
              <Group boxSize={24} m={6} color="primary" />
            </Avatar>
            <Flex direction="column" gap={2}>
              <Flex
                sx={{
                  flexDir: { base: 'column', md: 'row' },
                  alignItems: { base: 'start', md: 'center' },
                  gap: { base: 1, md: 4 },
                }}
              >
                {flexGroup?.name ? (
                  <Heading
                    sx={{
                      fontSize: { base: '2xl', md: '4xl' },
                      fontWeight: 'semibold',
                      color: 'white',
                    }}
                  >
                    {flexGroup?.name}
                  </Heading>
                ) : (
                  <Skeleton isLoaded={!isLoading} w={56} h={8} />
                )}
                <Flex gap={2} alignItems={'center'}>
                  {flexGroup?.valid != undefined && (
                    <ValidityBadge valid={flexGroup?.valid} />
                  )}
                </Flex>
              </Flex>
              {flexGroup?.description && (
                <HStack>
                  <TextUnorderedList boxSize={'16px'} />
                  <Text color='white'>{flexGroup.description}</Text>
                </HStack>
              )}
              <HStack mt='auto'>
                <Icon as={FontAwesomeIcon} icon={faGear} boxSize={'16px'} />
                <Text color='white'>{type?.name} - {type?.description}</Text>
              </HStack>
            </Flex>
          </Flex>
          <Stack justifyContent="end" alignItems="end">
            <HeaderButton
              onClick={() => navigate('edit')}
              variant="solid"
              colorScheme="primary"
              _hover={{ bg: 'primary.600' }}>
              <Edit />
              Upravit
            </HeaderButton>
          </Stack>
        </Flex>
      </Container>
    </Grid>
  )
}
